import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  QueryList,
} from '@angular/core'
import {TocItemComponent} from './toc-item/toc-item.component'
import {isPlatformBrowser} from '@angular/common'
import {Subject} from 'rxjs'

@Component({
  selector: 'cft-table-of-content',
  templateUrl: './table-of-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block; }'],
  standalone: false,
})
export class TableOfContentComponent implements OnDestroy {
  @Input({required: true}) title!: string

  @ContentChildren(TocItemComponent) items!: QueryList<TocItemComponent>

  private readonly unsubscribe$ = new Subject<void>()
  private observer?: IntersectionObserver

  constructor(@Inject(PLATFORM_ID) private platformId: Record<string, unknown>) {
    afterNextRender(() => this.observeScroll())
  }

  observeScroll() {
    if (!isPlatformBrowser(this.platformId)) {
      return
    }

    const items = this.items.toArray().map(i => ({component: i, anchorElement: i.getAnchorElement()}))

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(e => {
          const currentIndex = items.findIndex(i => i.anchorElement === e.target)

          if (e.isIntersecting) {
            items.forEach((item, index) => (item.component.active = index <= currentIndex))
          } else if ((e.rootBounds?.y || 0) < e.boundingClientRect.y) {
            items[currentIndex].component.active = false
          }
        })
      },
      {rootMargin: '-30%'},
    )

    items.forEach(i => this.observer?.observe(i.anchorElement))
  }

  ngOnDestroy(): void {
    this.observer?.disconnect()
    this.observer = undefined
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
